// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nrwl/web/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message_message__31siW {\n  position: absolute;\n  top: 40px;\n  z-index: 10;\n  left: 50%;\n  transition: all 0.3s ease;\n  opacity: 0;\n  padding: 10px;\n  background-color: var(--orange);\n  color: var(--text-primary);\n  border-radius: 6px;\n  animation: message_flyin__LA5ah 6s ease 0.1s alternate;\n}\n\n@keyframes message_flyin__LA5ah {\n  0% {\n    opacity: 0;\n    transform: translate(-50%, -20px);\n  }\n  10% {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n  80% {\n    opacity: 1;\n    transform: translate(-50%, 0);\n  }\n  90% {\n    opacity: 0;\n    transform: translate(-50%, -20px);\n  }\n}\n.message_error__2fraE {\n  border: 1px solid red;\n}\n\n.message_warning__Z2aSr {\n  border: 1px solid yellow;\n}\n\n.message_success__3h81i {\n  border: 1px solid green;\n}", ""]);
// Exports
exports.locals = {
	"message": "message_message__31siW",
	"flyin": "message_flyin__LA5ah",
	"error": "message_error__2fraE",
	"warning": "message_warning__Z2aSr",
	"success": "message_success__3h81i"
};
module.exports = exports;
